// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../js/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../js/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* redesign.css contains a lot of the 'bootstrap' type css,
   especially for the 'old' dashboard, the left hand locale picker, etc.
*/

/*
    Created on : Feb 21, 2014, 11:08:36 AM
    Author     : pwauquie
*/

.hasTooltip {
	cursor: pointer;
}

.collapse-review span.glyphicon-chevron-down {
	margin-right: 10px;
	position: relative;
	top: 4px;
}

.table-wrapper table tr td:nth-child(6) {
    width:30px;
}

.table-wrapper table tr td:nth-child(5) {
    width:188px;
}

tr.hidden-line {
    display: none;
}

tr.hidden-line.data-review {
	background-color:#fcf8e3;
}

tr.shown {
    display: table-row;
}

.menu-position {
    position: fixed;
    background-color: white;
    z-index: 800;
}

p.specialmessage {
    display:  inline;
    font-size:  smaller;
    width: 210px;
	height:34px;
	overflow:hidden;
}

.menu-review .popover{
	color:#3399f3;
	width:250px;
}

.info-review {
    width: 5%;
}

.fix-parent {
	display:inline-block;
	position:relative;
}

.affix-top, .affix, .right-info  {
	position:absolute;
    top:180px;
    width:23%;
}

.table-review .label {
	font-size:14px;
}

th[dir=rtl] {
	text-align:right;
}

h3.collapse-review {position:relative}
h3.collapse-review > span:first-child {position: relative; top: -220px;display: block}

.show-items {
	cursor:pointer;
	margin-right:6px;
}

.fix-info, .fix-info>td {
    padding: 0px!important;
    border-top: 0px!important;

}

.fix-info .fix-content {
    display: none;
}

.collapse-review {
	padding-bottom: 5px;
}

.menu-review {
	background-color: #f5f5f5;
	border-radius:5px;
	padding:5px;
	border:1px solid #ddd;
	min-width:320px;
	top:60px;
}

.menu-review .inactive {
	color:#747A80;
}

.claro .dijitContentPane {
	padding:0px;
}

.data-review:hover > td, .collapse-review:hover {
	background-color: #f5f5f5;
}

#post-form {
	margin-bottom:20px;
}

.table-review .xpath {
	display:none;
}
.table-review .fix-popover-help {
	font-size:12px;
}

.table-review .popover {
	min-width:35%;

}

.fix-parent > .popover {
	min-width:750px;
}

.data-vertical .pu-select {
	border:none !important;
}

.data-vote {
	padding-left:2%;
	border-left:1px solid #eeeeee;
	margin-left:-5px;
}

.data-vertical {
	padding-right:2%;
	border-right:1px solid #eeeeee;
}
.data-vertical, .data-vote {
	display:inline-block;
	width:50%;
	vertical-align:top;
}

.data-vertical .d-no-vo-false, .data-vertical .d-no-vo-true  {
	background:none;
	text-align:left;
}

/* This affects the position of the Abstain button in Dashboard Fix.
	The "!important" here is to prevent being overridden by the "padding:0"
	style below with the complex "...:not..." selector. */
.data-vertical .nocell {
	padding-top: 9px !important;
	padding-bottom: 3px !important;
}

.value-div .voteInfo_iconBar {
	top:-2px;
}

.data-vertical hr{
	margin-top:10px;
	margin-bottom:10px;
}

.data-vertical div[class*=d-]:not(.d-example) {
	padding:0;
}

.data-vertical .othercell .form-inline {
	height :38px;
}

.help-vote {
	color:gray;
	font-weight: normal;
	font-style: italic;
	display: inline-block;
	float: right;
	position:relative;
	top:5px;
	height: 35px;
}

.othercell .form-inline {
	display:inline-block;
}

.data-vertical .d-item-warn {
	border-radius:5px;
	padding: 10px !important;
	padding-right:2px !important;
	margin-left: -10px;
}

.data .choice-field {
	display:inline-block;
	width:100%;
}

.data .cancelbutton {
	margin-left:5px;
	float:right;
}

.data label {
	cursor:pointer;
}

.data .subSpan {
	margin-left:9px;
	position:relative;
	top:2px;
}

.table-vote {
	margin-top:10px;
	margin-bottom:2px;
}


.d-win hr {
	margin-top:10px;
	margin-bottom:10px;
}

.trInfo {
	margin-top:15px;
}

.dashboard .headingb {
	display:none;
}

.label-icon {
	font-size: 0.8em !important;
	position:relative;
	top:-1px;
	padding-top: 0px;
	padding-bottom: 2px;
	vertical-align: middle;
}
.voteInfo_tr_heading > td > span {
	position:relative;
	top:2px;
}

.value-div:not(.first) {
	padding-top: 25px;
	margin-top: 10px;
	border-top: 1px solid #eeeeee;

}

.winner, .value {
	font-weight:bold;
}

.value-div .winner, .value-div .value {
	font-size:16px;
}

.button-add input.form-control {
	width: 294px;
}

.button-add .popover {
	min-width:0px;
}

.othercell hr {
	border-top:1px solid white;
}
.copyEnglish {
    margin-top: 5px;
    position: relative;
    left: 10px;
}
.copyWinning {
    margin-top: 5px;
    position: relative;
    left: 20px;
}
.data .close {
	position: absolute;
	top: 6px;
	right: 9px;
}

.data .comparisoncell {
	cursor:pointer;
}

.fix-parent .link-main {
	margin-left:10px;
}

/*change in surveytool.css*/
.topLocaleRow {
	border:1px solid black;
	border-radius: 5px;
	margin-top:5px;
	margin-bottom:5px;
	padding : 5px;
}

.data .d-example {
	display:none;
}
.data .d-trans-hint {
	display:none;
}
/* direct override of bootstrap
   TODO: explain and/or reevaluate this "override". Potentially problematic for performance
   (especially z-index) and compatibility with newer versions of bootstrap if we update. */
.table>thead>tr>th, .table>tbody>tr>th, .table>tfoot>tr>th, .table>thead>tr>td, .table>tbody>tr>td, .table>tfoot>tr>td {vertical-align:middle}
.modal-backdrop {z-index:140;}
.modal {z-index:141;}

/*sidebar stuff*/
.nav-pills>li>a {
	border-radius:0px;
}

#left-sidebar {
	height:calc(100% - 50px);
	position:fixed;
	top:50px;
	width:20%;
	left:-18%;
	left:calc(-18% - 1px);
	transition:left 0.5s ease;
	z-index:801;
	background-color:white;
}

#left-sidebar.active {
	left:0%;
	min-width:280px;
}
#dragger {
	width:10%;
	background-image: linear-gradient(#fff, #eee 50%, #e4e4e4);
	background-repeat: no-repeat;
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#ffe4e4e4', GradientType=0);
	filter: none;
	border:1px solid #d5d5d5;
	float:right;
	height:100%;
}

#content-sidebar {
	width:90%;
	height:100%;
	float:left;
	padding-bottom:35px;
}

#locale-info, #locale-list, #locale-menu {
	margin:10px;
}

#locale-list , #locale-menu {
	border-radius: 5px;
	overflow:scroll;
	background-color:#f5f5f5;
	border:1px solid #ddd;
}

#locale-list {
	height:92%;
	max-height:95%;
	transition: height 0.5s ease;
}

#locale-list.active {
	height:20%;
}

#locale-menu {
	height:0%;
	transition: height 0.5s ease;
	color:#3399f3;
}

#locale-menu.active {
	height:72%;
}

#locale-list .topLocaleRow {
	border:none;
}
#locale-list .topLocaleRow .subLocaleList .subLocale{
	display:inline-block;
}

#locale-list .topLocaleRow .subLocaleList {
	padding-left:25px;
}

#locale-list a {
	font-size:0.8em;
}

#locale-list .topLocaleRow a:hover, #locale-list .topLocaleRow a.active {
	background-color:#446e9b;
	color:white;
}

#dragger span {
	display:block;
	position:relative;
	left:calc(50% - 9px);
	top:35px;
	font-size:18px;
	width:24px;
}


.sidebar-chooser  {
	cursor:pointer;
}

#locale-menu > ul {
	padding:10px;
}

#locale-check-group {
	padding:5px;
	font-size:12px;
}

.v-status img {
    margin-right:  3px;
}

div#additional-top div.topnotices {
    position:  fixed;
    left:  0;
    top:  0;
}

div#additional-top div.beta,
div#additional-top div.beta span#betanotice  {
    position: inherit !important;
    right:  inherit !important;
    top: inherit !important;
    background-color: #fbfac1;
    border:  none;
}

#locale-clear {
	position: relative;
	color: darkgray;
	cursor:pointer;
	top:-25px;
	left:95%;
	z-index: 10;
	float:left;
}

#locale-clear:hover {
	color:black;
}

#flag-info {
	position:relative;
	left:-20px;
}

#flag-info img {
	position:relative;
	top:-2px;
	cursor:pointer;
}

#locale-menu div {
	padding:5px;
	padding-left:10px;
	width:100%;
	cursor:pointer;
}


#locale-menu li:hover > div {
	color:white;
	background-color:#446e9b;
}
.refresh-search {
	cursor:pointer;
}

#overlay {
	opacity:0;
	background-color:black;
	position:fixed;
	height:100%;
	width:100%;
	top:0px;
	z-index: -10;
	transition: opacity 0.5s ease;
}

#overlay.active {
	opacity:0.5;
}

#alert-info {
	white-space:nowrap;
	margin-top:-20px;
	margin: auto;
	margin-top: -18px;
	width:500px;
}

/* help content */

div.helpAbstract {
    font-size: smaller;
    overflow: hidden;
    height: 10em;
    padding: .25em;
    font-style: italic;
    position: relative;
}

.helpAbstract a {
    font-size: small;
    text-decoration: none !important;
    overflow: visible !important;
    position: absolute;
    right: 0;
    bottom: 0;
    text-align: right;
    width: 100%;
    background-color: #d9edf7;
    opacity: 1;
}

div.placeholderHelp {
	border: 2px solid gray;
	padding: .3em;
}

.placeholderInfo {
	display: table;
}

.placeholderRow {
	display: table-row;
}

.placeholderRow > span {
	display: table-cell;
	padding: .2em;
}

.placeholderHeading > span {
	font-weight: bold;
	border-bottom: 1px solid black;
}

.nav .popover {
	position:fixed;
}

.popover {
	z-index:100;
}

.vetting-page .othercell hr {
	margin-top:2px;
	margin-bottom:2px;
}

.vetting-page .button-add input  {
		width:70%;
}

/*bootstrap overide for flat button*/
.btn-success {
  color: #fff;
  background-color: #5cb85c;
  border-color: #4cae4c;
  background-image:none;
}
.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.open .dropdown-toggle.btn-success {
  color: #fff;
  background-color: #47a447;
  border-color: #398439;
  background-image:none;
}
.btn-success:active,
.btn-success.active,
.open .dropdown-toggle.btn-success {
  background-image: none;
}
.btn-success.disabled,
.btn-success[disabled],
fieldset[disabled] .btn-success,
.btn-success.disabled:hover,
.btn-success[disabled]:hover,
fieldset[disabled] .btn-success:hover,
.btn-success.disabled:focus,
.btn-success[disabled]:focus,
fieldset[disabled] .btn-success:focus,
.btn-success.disabled:active,
.btn-success[disabled]:active,
fieldset[disabled] .btn-success:active,
.btn-success.disabled.active,
.btn-success[disabled].active,
fieldset[disabled] .btn-success.active {
  background-color: #5cb85c;
  border-color: #4cae4c;
  background-image:none;

}
.btn-success .badge {
  color: #5cb85c;
  background-color: #fff;
}
.btn-info {
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
  background-image:none;
}
.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active,
.open .dropdown-toggle.btn-info {
  color: #fff;
  background-color: #39b3d7;
  border-color: #269abc;
  background-image:none;
}
.btn-info:active,
.btn-info.active,
.open .dropdown-toggle.btn-info {
  background-image: none;
}
.btn-info.disabled,
.btn-info[disabled],
fieldset[disabled] .btn-info,
.btn-info.disabled:hover,
.btn-info[disabled]:hover,
fieldset[disabled] .btn-info:hover,
.btn-info.disabled:focus,
.btn-info[disabled]:focus,
fieldset[disabled] .btn-info:focus,
.btn-info.disabled:active,
.btn-info[disabled]:active,
fieldset[disabled] .btn-info:active,
.btn-info.disabled.active,
.btn-info[disabled].active,
fieldset[disabled] .btn-info.active {
  background-color: #5bc0de;
  border-color: #46b8da;
  background-image:none;
}
.btn-info .badge {
  color: #5bc0de;
  background-color: #fff;
}
.btn-warning {
  color: #fff;
  background-color: #f0ad4e;
  border-color: #eea236;
  background-image:none;
}
.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active,
.open .dropdown-toggle.btn-warning {
  color: #fff;
  background-color: #ed9c28;
  border-color: #d58512;
  background-image:none;
}
.btn-warning:active,
.btn-warning.active,
.open .dropdown-toggle.btn-warning {
  background-image: none;
}
.btn-warning.disabled,
.btn-warning[disabled],
fieldset[disabled] .btn-warning,
.btn-warning.disabled:hover,
.btn-warning[disabled]:hover,
fieldset[disabled] .btn-warning:hover,
.btn-warning.disabled:focus,
.btn-warning[disabled]:focus,
fieldset[disabled] .btn-warning:focus,
.btn-warning.disabled:active,
.btn-warning[disabled]:active,
fieldset[disabled] .btn-warning:active,
.btn-warning.disabled.active,
.btn-warning[disabled].active,
fieldset[disabled] .btn-warning.active {
  background-color: #f0ad4e;
  border-color: #eea236;
  background-image:none;
}
.btn-warning .badge {
  color: #f0ad4e;
  background-color: #fff;
}
.btn-danger {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
  background-image:none;
}
.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active,
.open .dropdown-toggle.btn-danger {
  color: #fff;
  background-color: #d2322d;
  border-color: #ac2925;
  background-image:none;
}
.btn-danger:active,
.btn-danger.active,
.open .dropdown-toggle.btn-danger {
  background-image: none;
}
.btn-danger.disabled,
.btn-danger[disabled],
fieldset[disabled] .btn-danger,
.btn-danger.disabled:hover,
.btn-danger[disabled]:hover,
fieldset[disabled] .btn-danger:hover,
.btn-danger.disabled:focus,
.btn-danger[disabled]:focus,
fieldset[disabled] .btn-danger:focus,
.btn-danger.disabled:active,
.btn-danger[disabled]:active,
fieldset[disabled] .btn-danger:active,
.btn-danger.disabled.active,
.btn-danger[disabled].active,
fieldset[disabled] .btn-danger.active {
  background-color: #d9534f;
  border-color: #d43f3a;
  background-image:none;
}
.btn-danger .badge {
  color: #d9534f;
  background-color: #fff;
}
.btn-link {
  font-weight: normal;
  color: #428bca;
  cursor: pointer;
  border-radius: 0;
  background-image:none;
}
.btn-link,
.btn-link:active,
.btn-link[disabled],
fieldset[disabled] .btn-link {
  background-color: transparent;
          box-shadow: none;
}
.btn-link,
.btn-link:hover,
.btn-link:focus,
.btn-link:active {
  border-color: transparent;
}
.btn-link:hover,
.btn-link:focus {
  color: #2a6496;
  text-decoration: underline;
  background-color: transparent;
  background-image:none;
}
.btn-link[disabled]:hover,
fieldset[disabled] .btn-link:hover,
.btn-link[disabled]:focus,
fieldset[disabled] .btn-link:focus {
  color: #999;
  text-decoration: none;
}
.btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc;
  background-image:none;
}
.btn-default:hover,
.btn-default:focus,
.btn-default:active,
.btn-default.active,
.open .dropdown-toggle.btn-default {
  color: #333;
  background-color: #ebebeb;
  border-color: #adadad;
  background-image:none;
}
.btn-default:active,
.btn-default.active,
.open .dropdown-toggle.btn-default {
  background-image: none;
}
.btn-default.disabled,
.btn-default[disabled],
fieldset[disabled] .btn-default,
.btn-default.disabled:hover,
.btn-default[disabled]:hover,
fieldset[disabled] .btn-default:hover,
.btn-default.disabled:focus,
.btn-default[disabled]:focus,
fieldset[disabled] .btn-default:focus,
.btn-default.disabled:active,
.btn-default[disabled]:active,
fieldset[disabled] .btn-default:active,
.btn-default.disabled.active,
.btn-default[disabled].active,
fieldset[disabled] .btn-default.active {
  background-color: #fff;
  border-color: #ccc;
}
.btn-default .badge {
  color: #fff;
  background-color: #333;
}
.btn-primary {
  color: #fff;
  background-color: #428bca;
  border-color: #357ebd;
  background-image:none;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.open .dropdown-toggle.btn-primary {
  color: #fff;
  background-color: #3276b1;
  border-color: #285e8e;
  background-image:none;
}
.btn-primary:active,
.btn-primary.active,
.open .dropdown-toggle.btn-primary {
  background-image: none;
}
.btn-primary.disabled,
.btn-primary[disabled],
fieldset[disabled] .btn-primary,
.btn-primary.disabled:hover,
.btn-primary[disabled]:hover,
fieldset[disabled] .btn-primary:hover,
.btn-primary.disabled:focus,
.btn-primary[disabled]:focus,
fieldset[disabled] .btn-primary:focus,
.btn-primary.disabled:active,
.btn-primary[disabled]:active,
fieldset[disabled] .btn-primary:active,
.btn-primary.disabled.active,
.btn-primary[disabled].active,
fieldset[disabled] .btn-primary.active {
  background-color: #428bca;
  border-color: #357ebd;
}
.btn-primary .badge {
  color: #428bca;
  background-color: #fff;
}

.subSpan [dir=rtl] {
	padding-left: 8px;
	padding-right: 10px;
}

.value-div[dir=rtl] .voteInfo_iconBar {
	margin-right: 5px;
}

#MainContentPane {
	overflow:visible;
}

#post-form textarea {
	resize:none;
}

.modal-content {
	margin-top: 100px;
}

/* feedback part */
#feedback {
	position:fixed;
	right:0px;
	bottom:0px;
	z-index:800;
}

#feedback > div {
	cursor:pointer;
}

#feedback label, #feedback input {
	width:100%;
}
#feedback form {
	display:none;
	font-size:12px;
}

#popover-vote label, .fix-parent .othercell {
	direction:ltr;
}

/***
 The following is here in redesign.css temporarily!
 Note: redesign.css is loaded by SurveyTool.java AFTER surveytool.css and bootstrap, so has higher priority;
 style.css (for webpack, currently empty) is effectively loaded first, has the lowest priority
***/

body,
html {
	width: 100vw !important;
	height: 100vh !important;
	overflow: hidden !important;
	margin: 0 !important;
	padding: 0 !important;
}

#st-run-gui {
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	width: 100%;
	height: 100%;
	overflow: hidden;
	justify-content: space-between;
	margin: 0;
	padding: 0;
}

.sidebyside {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	flex: 1;
	width: 100%;
	overflow: hidden;
	margin: 0;
	padding: 0;
}

.sidebyside-column {
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.sidebyside-wide {
	width: 75%;
}

.sidebyside-narrow {
	width: 25%;
	border-left: 2px solid #cfeaf8;
}

.sidebyside-column-top {
	flex: none;
	margin: 0;
}

.sidebyside-scrollable {
	margin: 4px;
	overflow: auto;
}

#toptitle {
	font-size: medium;
	display: none;
	padding-top: 0;
	padding-bottom: 0.25em;
	margin-top: 0.25em;
	margin-bottom: 0;
	margin-left: 1ex;
	border-bottom: 2px solid #cfeaf8;
}

#toptitle span.title-cldr {
	font-weight: bold;
}

#toptitle h1 {
	display: inline-block;
	font-size: 28px;
	margin: 0;
}

#toptitle h1::before {
	content: " / ";
}

#toptitle #title-locale-container h1::before {
	content: "";
}

#itemInfo div.xpath {
	position: fixed;
	right: 0.1em;
	bottom: 0.1em;
	color: #a19a9a;
	padding:  2px;
	border:  1px solid white;
	font-family: "Courier New", Courier, mono;
	font-weight: bold;
}

#itemInfo div.xpath:hover {
	opacity: 1;
	color: navy;
	border:  1px solid silver;
	background-color: white;
}

.beware-left-sidebar {
	/* The left sidebar "slider" width is 2% ( = 20% x 10%); cf. #itemInfo div.xpath */
	padding-left: 2.1%;
}

#nav-page {
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	margin: 0.25em 0.25em 0 0;
	padding: 0;
	box-sizing: border-box;
}

.cldr-nav-btn {
	padding: 1px 5px;
	margin-left: 0;
	margin-right: 1ex;
	font-size: 12px;
	line-height: 1.5;
	border-radius: 3px;
}

.nav-progress {
	width: 150px;
	height: 20px;
	margin: 0 8px 4px 0;
	display: inline-block;
	vertical-align: middle;
}

#VotingEtcSection {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	flex: none;
	overflow: hidden;
}

#DynamicDataSection {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;
	overflow: auto;
}

#DashboardSection {
	width: 100%;
	height: 50%;
	display: none;
	flex-direction: column;
	overflow: hidden;
}

footer {
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	text-align: center;
	border-top: 0.5em solid #eeeefe;
	font-size: smaller;
}
`, "",{"version":3,"sources":["webpack://./../src/main/webapp/css/redesign.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;;;CAGC;;AAED;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;AACT;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;CACf,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,WAAW;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;CACC,oBAAoB;CACpB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;IACd,SAAS;IACT,SAAS;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA,oBAAoB,iBAAiB;AACrC,uCAAuC,kBAAkB,EAAE,WAAW,CAAC,cAAc;;AAErF;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,iBAAiB;CACjB,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;AACA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;;AAEd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,8BAA8B;AAC/B;AACA;CACC,oBAAoB;CACpB,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;;sDAEsD;AACtD;CACC,2BAA2B;CAC3B,8BAA8B;AAC/B;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,UAAU;CACV,mBAAmB;CACnB,kBAAkB;CAClB,qBAAqB;CACrB,YAAY;CACZ,iBAAiB;CACjB,OAAO;CACP,YAAY;AACb;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,UAAU;AACX;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,OAAO;AACR;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;;AAGA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2BAA2B;CAC3B,iBAAiB;CACjB,QAAQ;CACR,gBAAgB;CAChB,mBAAmB;CACnB,sBAAsB;AACvB;AACA;CACC,iBAAiB;CACjB,OAAO;AACR;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,6BAA6B;;AAE9B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,0BAA0B;AAC3B;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA,2BAA2B;AAC3B;CACC,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;;0FAE0F;AAC1F,wHAAwH,qBAAqB;AAC7I,iBAAiB,WAAW,CAAC;AAC7B,QAAQ,WAAW,CAAC;;AAEpB,gBAAgB;AAChB;CACC,iBAAiB;AAClB;;AAEA;CACC,wBAAwB;CACxB,cAAc;CACd,QAAQ;CACR,SAAS;CACT,SAAS;CACT,qBAAqB;CACrB,yBAAyB;CACzB,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,OAAO;CACP,eAAe;AAChB;AACA;CACC,SAAS;CACT,0DAA0D;CAC1D,4BAA4B;CAC5B,sHAAsH;CACtH,YAAY;CACZ,wBAAwB;CACxB,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,WAAW;CACX,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA;CACC,UAAU;CACV,cAAc;CACd,4BAA4B;AAC7B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,SAAS;CACT,4BAA4B;CAC5B,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,wBAAwB;CACxB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,oBAAoB;CACpB,QAAQ;CACR,cAAc;CACd,UAAU;AACX;;;AAGA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,OAAO;AACX;;AAEA;;IAEI,4BAA4B;IAC5B,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,SAAS;CACT,QAAQ;CACR,WAAW;CACX,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,UAAU;AACX;;AAEA;CACC,iBAAiB;CACjB,QAAQ;CACR,cAAc;AACf;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,UAAU;CACV,cAAc;AACf;;;AAGA;CACC,WAAW;CACX,wBAAwB;AACzB;AACA;CACC,cAAc;AACf;;AAEA;CACC,SAAS;CACT,sBAAsB;CACtB,cAAc;CACd,WAAW;CACX,UAAU;CACV,OAAO;CACP,YAAY;CACZ,6BAA6B;AAC9B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;CACZ,iBAAiB;CACjB,WAAW;AACZ;;AAEA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,4BAA4B;IAC5B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,UAAU;AACd;;AAEA;CACC,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,8BAA8B;AAC/B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;;EAGE,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;EAeE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;;AAEvB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;;EAGE,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;EAeE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;;EAGE,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;EAeE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;;EAGE,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;EAeE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;;;EAIE,6BAA6B;UACrB,gBAAgB;AAC1B;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;;;EAIE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;;EAGE,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;EAeE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;;EAGE,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;EAeE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA,kBAAkB;AAClB;CACC,cAAc;CACd,SAAS;CACT,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;AACX;AACA;CACC,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;;;;GAIG;;AAEH;;CAEC,uBAAuB;CACvB,wBAAwB;CACxB,2BAA2B;CAC3B,oBAAoB;CACpB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,eAAe;CACf,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,8BAA8B;CAC9B,SAAS;CACT,UAAU;AACX;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,iBAAiB;CACjB,OAAO;CACP,WAAW;CACX,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;CACV,8BAA8B;AAC/B;;AAEA;CACC,UAAU;CACV,SAAS;AACV;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,cAAc;CACd,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,gCAAgC;AACjC;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,SAAS;AACV;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,aAAa;CACb,cAAc;CACd,aAAa;CACb,wBAAwB;CACxB,yCAAyC;CACzC,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,yBAAyB;CACzB,uBAAuB;AACxB;;AAEA;CACC,kFAAkF;CAClF,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,8BAA8B;CAC9B,mBAAmB;CACnB,yBAAyB;CACzB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,OAAO;CACP,cAAc;AACf;;AAEA;CACC,WAAW;CACX,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,+BAA+B;CAC/B,kBAAkB;AACnB","sourcesContent":["/* redesign.css contains a lot of the 'bootstrap' type css,\n   especially for the 'old' dashboard, the left hand locale picker, etc.\n*/\n\n/*\n    Created on : Feb 21, 2014, 11:08:36 AM\n    Author     : pwauquie\n*/\n\n.hasTooltip {\n\tcursor: pointer;\n}\n\n.collapse-review span.glyphicon-chevron-down {\n\tmargin-right: 10px;\n\tposition: relative;\n\ttop: 4px;\n}\n\n.table-wrapper table tr td:nth-child(6) {\n    width:30px;\n}\n\n.table-wrapper table tr td:nth-child(5) {\n    width:188px;\n}\n\ntr.hidden-line {\n    display: none;\n}\n\ntr.hidden-line.data-review {\n\tbackground-color:#fcf8e3;\n}\n\ntr.shown {\n    display: table-row;\n}\n\n.menu-position {\n    position: fixed;\n    background-color: white;\n    z-index: 800;\n}\n\np.specialmessage {\n    display:  inline;\n    font-size:  smaller;\n    width: 210px;\n\theight:34px;\n\toverflow:hidden;\n}\n\n.menu-review .popover{\n\tcolor:#3399f3;\n\twidth:250px;\n}\n\n.info-review {\n    width: 5%;\n}\n\n.fix-parent {\n\tdisplay:inline-block;\n\tposition:relative;\n}\n\n.affix-top, .affix, .right-info  {\n\tposition:absolute;\n    top:180px;\n    width:23%;\n}\n\n.table-review .label {\n\tfont-size:14px;\n}\n\nth[dir=rtl] {\n\ttext-align:right;\n}\n\nh3.collapse-review {position:relative}\nh3.collapse-review > span:first-child {position: relative; top: -220px;display: block}\n\n.show-items {\n\tcursor:pointer;\n\tmargin-right:6px;\n}\n\n.fix-info, .fix-info>td {\n    padding: 0px!important;\n    border-top: 0px!important;\n\n}\n\n.fix-info .fix-content {\n    display: none;\n}\n\n.collapse-review {\n\tpadding-bottom: 5px;\n}\n\n.menu-review {\n\tbackground-color: #f5f5f5;\n\tborder-radius:5px;\n\tpadding:5px;\n\tborder:1px solid #ddd;\n\tmin-width:320px;\n\ttop:60px;\n}\n\n.menu-review .inactive {\n\tcolor:#747A80;\n}\n\n.claro .dijitContentPane {\n\tpadding:0px;\n}\n\n.data-review:hover > td, .collapse-review:hover {\n\tbackground-color: #f5f5f5;\n}\n\n#post-form {\n\tmargin-bottom:20px;\n}\n\n.table-review .xpath {\n\tdisplay:none;\n}\n.table-review .fix-popover-help {\n\tfont-size:12px;\n}\n\n.table-review .popover {\n\tmin-width:35%;\n\n}\n\n.fix-parent > .popover {\n\tmin-width:750px;\n}\n\n.data-vertical .pu-select {\n\tborder:none !important;\n}\n\n.data-vote {\n\tpadding-left:2%;\n\tborder-left:1px solid #eeeeee;\n\tmargin-left:-5px;\n}\n\n.data-vertical {\n\tpadding-right:2%;\n\tborder-right:1px solid #eeeeee;\n}\n.data-vertical, .data-vote {\n\tdisplay:inline-block;\n\twidth:50%;\n\tvertical-align:top;\n}\n\n.data-vertical .d-no-vo-false, .data-vertical .d-no-vo-true  {\n\tbackground:none;\n\ttext-align:left;\n}\n\n/* This affects the position of the Abstain button in Dashboard Fix.\n\tThe \"!important\" here is to prevent being overridden by the \"padding:0\"\n\tstyle below with the complex \"...:not...\" selector. */\n.data-vertical .nocell {\n\tpadding-top: 9px !important;\n\tpadding-bottom: 3px !important;\n}\n\n.value-div .voteInfo_iconBar {\n\ttop:-2px;\n}\n\n.data-vertical hr{\n\tmargin-top:10px;\n\tmargin-bottom:10px;\n}\n\n.data-vertical div[class*=d-]:not(.d-example) {\n\tpadding:0;\n}\n\n.data-vertical .othercell .form-inline {\n\theight :38px;\n}\n\n.help-vote {\n\tcolor:gray;\n\tfont-weight: normal;\n\tfont-style: italic;\n\tdisplay: inline-block;\n\tfloat: right;\n\tposition:relative;\n\ttop:5px;\n\theight: 35px;\n}\n\n.othercell .form-inline {\n\tdisplay:inline-block;\n}\n\n.data-vertical .d-item-warn {\n\tborder-radius:5px;\n\tpadding: 10px !important;\n\tpadding-right:2px !important;\n\tmargin-left: -10px;\n}\n\n.data .choice-field {\n\tdisplay:inline-block;\n\twidth:100%;\n}\n\n.data .cancelbutton {\n\tmargin-left:5px;\n\tfloat:right;\n}\n\n.data label {\n\tcursor:pointer;\n}\n\n.data .subSpan {\n\tmargin-left:9px;\n\tposition:relative;\n\ttop:2px;\n}\n\n.table-vote {\n\tmargin-top:10px;\n\tmargin-bottom:2px;\n}\n\n\n.d-win hr {\n\tmargin-top:10px;\n\tmargin-bottom:10px;\n}\n\n.trInfo {\n\tmargin-top:15px;\n}\n\n.dashboard .headingb {\n\tdisplay:none;\n}\n\n.label-icon {\n\tfont-size: 0.8em !important;\n\tposition:relative;\n\ttop:-1px;\n\tpadding-top: 0px;\n\tpadding-bottom: 2px;\n\tvertical-align: middle;\n}\n.voteInfo_tr_heading > td > span {\n\tposition:relative;\n\ttop:2px;\n}\n\n.value-div:not(.first) {\n\tpadding-top: 25px;\n\tmargin-top: 10px;\n\tborder-top: 1px solid #eeeeee;\n\n}\n\n.winner, .value {\n\tfont-weight:bold;\n}\n\n.value-div .winner, .value-div .value {\n\tfont-size:16px;\n}\n\n.button-add input.form-control {\n\twidth: 294px;\n}\n\n.button-add .popover {\n\tmin-width:0px;\n}\n\n.othercell hr {\n\tborder-top:1px solid white;\n}\n.copyEnglish {\n    margin-top: 5px;\n    position: relative;\n    left: 10px;\n}\n.copyWinning {\n    margin-top: 5px;\n    position: relative;\n    left: 20px;\n}\n.data .close {\n\tposition: absolute;\n\ttop: 6px;\n\tright: 9px;\n}\n\n.data .comparisoncell {\n\tcursor:pointer;\n}\n\n.fix-parent .link-main {\n\tmargin-left:10px;\n}\n\n/*change in surveytool.css*/\n.topLocaleRow {\n\tborder:1px solid black;\n\tborder-radius: 5px;\n\tmargin-top:5px;\n\tmargin-bottom:5px;\n\tpadding : 5px;\n}\n\n.data .d-example {\n\tdisplay:none;\n}\n.data .d-trans-hint {\n\tdisplay:none;\n}\n/* direct override of bootstrap\n   TODO: explain and/or reevaluate this \"override\". Potentially problematic for performance\n   (especially z-index) and compatibility with newer versions of bootstrap if we update. */\n.table>thead>tr>th, .table>tbody>tr>th, .table>tfoot>tr>th, .table>thead>tr>td, .table>tbody>tr>td, .table>tfoot>tr>td {vertical-align:middle}\n.modal-backdrop {z-index:140;}\n.modal {z-index:141;}\n\n/*sidebar stuff*/\n.nav-pills>li>a {\n\tborder-radius:0px;\n}\n\n#left-sidebar {\n\theight:calc(100% - 50px);\n\tposition:fixed;\n\ttop:50px;\n\twidth:20%;\n\tleft:-18%;\n\tleft:calc(-18% - 1px);\n\ttransition:left 0.5s ease;\n\tz-index:801;\n\tbackground-color:white;\n}\n\n#left-sidebar.active {\n\tleft:0%;\n\tmin-width:280px;\n}\n#dragger {\n\twidth:10%;\n\tbackground-image: linear-gradient(#fff, #eee 50%, #e4e4e4);\n\tbackground-repeat: no-repeat;\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#ffe4e4e4', GradientType=0);\n\tfilter: none;\n\tborder:1px solid #d5d5d5;\n\tfloat:right;\n\theight:100%;\n}\n\n#content-sidebar {\n\twidth:90%;\n\theight:100%;\n\tfloat:left;\n\tpadding-bottom:35px;\n}\n\n#locale-info, #locale-list, #locale-menu {\n\tmargin:10px;\n}\n\n#locale-list , #locale-menu {\n\tborder-radius: 5px;\n\toverflow:scroll;\n\tbackground-color:#f5f5f5;\n\tborder:1px solid #ddd;\n}\n\n#locale-list {\n\theight:92%;\n\tmax-height:95%;\n\ttransition: height 0.5s ease;\n}\n\n#locale-list.active {\n\theight:20%;\n}\n\n#locale-menu {\n\theight:0%;\n\ttransition: height 0.5s ease;\n\tcolor:#3399f3;\n}\n\n#locale-menu.active {\n\theight:72%;\n}\n\n#locale-list .topLocaleRow {\n\tborder:none;\n}\n#locale-list .topLocaleRow .subLocaleList .subLocale{\n\tdisplay:inline-block;\n}\n\n#locale-list .topLocaleRow .subLocaleList {\n\tpadding-left:25px;\n}\n\n#locale-list a {\n\tfont-size:0.8em;\n}\n\n#locale-list .topLocaleRow a:hover, #locale-list .topLocaleRow a.active {\n\tbackground-color:#446e9b;\n\tcolor:white;\n}\n\n#dragger span {\n\tdisplay:block;\n\tposition:relative;\n\tleft:calc(50% - 9px);\n\ttop:35px;\n\tfont-size:18px;\n\twidth:24px;\n}\n\n\n.sidebar-chooser  {\n\tcursor:pointer;\n}\n\n#locale-menu > ul {\n\tpadding:10px;\n}\n\n#locale-check-group {\n\tpadding:5px;\n\tfont-size:12px;\n}\n\n.v-status img {\n    margin-right:  3px;\n}\n\ndiv#additional-top div.topnotices {\n    position:  fixed;\n    left:  0;\n    top:  0;\n}\n\ndiv#additional-top div.beta,\ndiv#additional-top div.beta span#betanotice  {\n    position: inherit !important;\n    right:  inherit !important;\n    top: inherit !important;\n    background-color: #fbfac1;\n    border:  none;\n}\n\n#locale-clear {\n\tposition: relative;\n\tcolor: darkgray;\n\tcursor:pointer;\n\ttop:-25px;\n\tleft:95%;\n\tz-index: 10;\n\tfloat:left;\n}\n\n#locale-clear:hover {\n\tcolor:black;\n}\n\n#flag-info {\n\tposition:relative;\n\tleft:-20px;\n}\n\n#flag-info img {\n\tposition:relative;\n\ttop:-2px;\n\tcursor:pointer;\n}\n\n#locale-menu div {\n\tpadding:5px;\n\tpadding-left:10px;\n\twidth:100%;\n\tcursor:pointer;\n}\n\n\n#locale-menu li:hover > div {\n\tcolor:white;\n\tbackground-color:#446e9b;\n}\n.refresh-search {\n\tcursor:pointer;\n}\n\n#overlay {\n\topacity:0;\n\tbackground-color:black;\n\tposition:fixed;\n\theight:100%;\n\twidth:100%;\n\ttop:0px;\n\tz-index: -10;\n\ttransition: opacity 0.5s ease;\n}\n\n#overlay.active {\n\topacity:0.5;\n}\n\n#alert-info {\n\twhite-space:nowrap;\n\tmargin-top:-20px;\n\tmargin: auto;\n\tmargin-top: -18px;\n\twidth:500px;\n}\n\n/* help content */\n\ndiv.helpAbstract {\n    font-size: smaller;\n    overflow: hidden;\n    height: 10em;\n    padding: .25em;\n    font-style: italic;\n    position: relative;\n}\n\n.helpAbstract a {\n    font-size: small;\n    text-decoration: none !important;\n    overflow: visible !important;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    text-align: right;\n    width: 100%;\n    background-color: #d9edf7;\n    opacity: 1;\n}\n\ndiv.placeholderHelp {\n\tborder: 2px solid gray;\n\tpadding: .3em;\n}\n\n.placeholderInfo {\n\tdisplay: table;\n}\n\n.placeholderRow {\n\tdisplay: table-row;\n}\n\n.placeholderRow > span {\n\tdisplay: table-cell;\n\tpadding: .2em;\n}\n\n.placeholderHeading > span {\n\tfont-weight: bold;\n\tborder-bottom: 1px solid black;\n}\n\n.nav .popover {\n\tposition:fixed;\n}\n\n.popover {\n\tz-index:100;\n}\n\n.vetting-page .othercell hr {\n\tmargin-top:2px;\n\tmargin-bottom:2px;\n}\n\n.vetting-page .button-add input  {\n\t\twidth:70%;\n}\n\n/*bootstrap overide for flat button*/\n.btn-success {\n  color: #fff;\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n  background-image:none;\n}\n.btn-success:hover,\n.btn-success:focus,\n.btn-success:active,\n.btn-success.active,\n.open .dropdown-toggle.btn-success {\n  color: #fff;\n  background-color: #47a447;\n  border-color: #398439;\n  background-image:none;\n}\n.btn-success:active,\n.btn-success.active,\n.open .dropdown-toggle.btn-success {\n  background-image: none;\n}\n.btn-success.disabled,\n.btn-success[disabled],\nfieldset[disabled] .btn-success,\n.btn-success.disabled:hover,\n.btn-success[disabled]:hover,\nfieldset[disabled] .btn-success:hover,\n.btn-success.disabled:focus,\n.btn-success[disabled]:focus,\nfieldset[disabled] .btn-success:focus,\n.btn-success.disabled:active,\n.btn-success[disabled]:active,\nfieldset[disabled] .btn-success:active,\n.btn-success.disabled.active,\n.btn-success[disabled].active,\nfieldset[disabled] .btn-success.active {\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n  background-image:none;\n\n}\n.btn-success .badge {\n  color: #5cb85c;\n  background-color: #fff;\n}\n.btn-info {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #46b8da;\n  background-image:none;\n}\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active,\n.open .dropdown-toggle.btn-info {\n  color: #fff;\n  background-color: #39b3d7;\n  border-color: #269abc;\n  background-image:none;\n}\n.btn-info:active,\n.btn-info.active,\n.open .dropdown-toggle.btn-info {\n  background-image: none;\n}\n.btn-info.disabled,\n.btn-info[disabled],\nfieldset[disabled] .btn-info,\n.btn-info.disabled:hover,\n.btn-info[disabled]:hover,\nfieldset[disabled] .btn-info:hover,\n.btn-info.disabled:focus,\n.btn-info[disabled]:focus,\nfieldset[disabled] .btn-info:focus,\n.btn-info.disabled:active,\n.btn-info[disabled]:active,\nfieldset[disabled] .btn-info:active,\n.btn-info.disabled.active,\n.btn-info[disabled].active,\nfieldset[disabled] .btn-info.active {\n  background-color: #5bc0de;\n  border-color: #46b8da;\n  background-image:none;\n}\n.btn-info .badge {\n  color: #5bc0de;\n  background-color: #fff;\n}\n.btn-warning {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236;\n  background-image:none;\n}\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning:active,\n.btn-warning.active,\n.open .dropdown-toggle.btn-warning {\n  color: #fff;\n  background-color: #ed9c28;\n  border-color: #d58512;\n  background-image:none;\n}\n.btn-warning:active,\n.btn-warning.active,\n.open .dropdown-toggle.btn-warning {\n  background-image: none;\n}\n.btn-warning.disabled,\n.btn-warning[disabled],\nfieldset[disabled] .btn-warning,\n.btn-warning.disabled:hover,\n.btn-warning[disabled]:hover,\nfieldset[disabled] .btn-warning:hover,\n.btn-warning.disabled:focus,\n.btn-warning[disabled]:focus,\nfieldset[disabled] .btn-warning:focus,\n.btn-warning.disabled:active,\n.btn-warning[disabled]:active,\nfieldset[disabled] .btn-warning:active,\n.btn-warning.disabled.active,\n.btn-warning[disabled].active,\nfieldset[disabled] .btn-warning.active {\n  background-color: #f0ad4e;\n  border-color: #eea236;\n  background-image:none;\n}\n.btn-warning .badge {\n  color: #f0ad4e;\n  background-color: #fff;\n}\n.btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n  background-image:none;\n}\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active,\n.btn-danger.active,\n.open .dropdown-toggle.btn-danger {\n  color: #fff;\n  background-color: #d2322d;\n  border-color: #ac2925;\n  background-image:none;\n}\n.btn-danger:active,\n.btn-danger.active,\n.open .dropdown-toggle.btn-danger {\n  background-image: none;\n}\n.btn-danger.disabled,\n.btn-danger[disabled],\nfieldset[disabled] .btn-danger,\n.btn-danger.disabled:hover,\n.btn-danger[disabled]:hover,\nfieldset[disabled] .btn-danger:hover,\n.btn-danger.disabled:focus,\n.btn-danger[disabled]:focus,\nfieldset[disabled] .btn-danger:focus,\n.btn-danger.disabled:active,\n.btn-danger[disabled]:active,\nfieldset[disabled] .btn-danger:active,\n.btn-danger.disabled.active,\n.btn-danger[disabled].active,\nfieldset[disabled] .btn-danger.active {\n  background-color: #d9534f;\n  border-color: #d43f3a;\n  background-image:none;\n}\n.btn-danger .badge {\n  color: #d9534f;\n  background-color: #fff;\n}\n.btn-link {\n  font-weight: normal;\n  color: #428bca;\n  cursor: pointer;\n  border-radius: 0;\n  background-image:none;\n}\n.btn-link,\n.btn-link:active,\n.btn-link[disabled],\nfieldset[disabled] .btn-link {\n  background-color: transparent;\n          box-shadow: none;\n}\n.btn-link,\n.btn-link:hover,\n.btn-link:focus,\n.btn-link:active {\n  border-color: transparent;\n}\n.btn-link:hover,\n.btn-link:focus {\n  color: #2a6496;\n  text-decoration: underline;\n  background-color: transparent;\n  background-image:none;\n}\n.btn-link[disabled]:hover,\nfieldset[disabled] .btn-link:hover,\n.btn-link[disabled]:focus,\nfieldset[disabled] .btn-link:focus {\n  color: #999;\n  text-decoration: none;\n}\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n  background-image:none;\n}\n.btn-default:hover,\n.btn-default:focus,\n.btn-default:active,\n.btn-default.active,\n.open .dropdown-toggle.btn-default {\n  color: #333;\n  background-color: #ebebeb;\n  border-color: #adadad;\n  background-image:none;\n}\n.btn-default:active,\n.btn-default.active,\n.open .dropdown-toggle.btn-default {\n  background-image: none;\n}\n.btn-default.disabled,\n.btn-default[disabled],\nfieldset[disabled] .btn-default,\n.btn-default.disabled:hover,\n.btn-default[disabled]:hover,\nfieldset[disabled] .btn-default:hover,\n.btn-default.disabled:focus,\n.btn-default[disabled]:focus,\nfieldset[disabled] .btn-default:focus,\n.btn-default.disabled:active,\n.btn-default[disabled]:active,\nfieldset[disabled] .btn-default:active,\n.btn-default.disabled.active,\n.btn-default[disabled].active,\nfieldset[disabled] .btn-default.active {\n  background-color: #fff;\n  border-color: #ccc;\n}\n.btn-default .badge {\n  color: #fff;\n  background-color: #333;\n}\n.btn-primary {\n  color: #fff;\n  background-color: #428bca;\n  border-color: #357ebd;\n  background-image:none;\n}\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary.active,\n.open .dropdown-toggle.btn-primary {\n  color: #fff;\n  background-color: #3276b1;\n  border-color: #285e8e;\n  background-image:none;\n}\n.btn-primary:active,\n.btn-primary.active,\n.open .dropdown-toggle.btn-primary {\n  background-image: none;\n}\n.btn-primary.disabled,\n.btn-primary[disabled],\nfieldset[disabled] .btn-primary,\n.btn-primary.disabled:hover,\n.btn-primary[disabled]:hover,\nfieldset[disabled] .btn-primary:hover,\n.btn-primary.disabled:focus,\n.btn-primary[disabled]:focus,\nfieldset[disabled] .btn-primary:focus,\n.btn-primary.disabled:active,\n.btn-primary[disabled]:active,\nfieldset[disabled] .btn-primary:active,\n.btn-primary.disabled.active,\n.btn-primary[disabled].active,\nfieldset[disabled] .btn-primary.active {\n  background-color: #428bca;\n  border-color: #357ebd;\n}\n.btn-primary .badge {\n  color: #428bca;\n  background-color: #fff;\n}\n\n.subSpan [dir=rtl] {\n\tpadding-left: 8px;\n\tpadding-right: 10px;\n}\n\n.value-div[dir=rtl] .voteInfo_iconBar {\n\tmargin-right: 5px;\n}\n\n#MainContentPane {\n\toverflow:visible;\n}\n\n#post-form textarea {\n\tresize:none;\n}\n\n.modal-content {\n\tmargin-top: 100px;\n}\n\n/* feedback part */\n#feedback {\n\tposition:fixed;\n\tright:0px;\n\tbottom:0px;\n\tz-index:800;\n}\n\n#feedback > div {\n\tcursor:pointer;\n}\n\n#feedback label, #feedback input {\n\twidth:100%;\n}\n#feedback form {\n\tdisplay:none;\n\tfont-size:12px;\n}\n\n#popover-vote label, .fix-parent .othercell {\n\tdirection:ltr;\n}\n\n/***\n The following is here in redesign.css temporarily!\n Note: redesign.css is loaded by SurveyTool.java AFTER surveytool.css and bootstrap, so has higher priority;\n style.css (for webpack, currently empty) is effectively loaded first, has the lowest priority\n***/\n\nbody,\nhtml {\n\twidth: 100vw !important;\n\theight: 100vh !important;\n\toverflow: hidden !important;\n\tmargin: 0 !important;\n\tpadding: 0 !important;\n}\n\n#st-run-gui {\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex-wrap: wrap;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: hidden;\n\tjustify-content: space-between;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.sidebyside {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tflex: 1;\n\twidth: 100%;\n\toverflow: hidden;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.sidebyside-column {\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: hidden;\n}\n\n.sidebyside-wide {\n\twidth: 75%;\n}\n\n.sidebyside-narrow {\n\twidth: 25%;\n\tborder-left: 2px solid #cfeaf8;\n}\n\n.sidebyside-column-top {\n\tflex: none;\n\tmargin: 0;\n}\n\n.sidebyside-scrollable {\n\tmargin: 4px;\n\toverflow: auto;\n}\n\n#toptitle {\n\tfont-size: medium;\n\tdisplay: none;\n\tpadding-top: 0;\n\tpadding-bottom: 0.25em;\n\tmargin-top: 0.25em;\n\tmargin-bottom: 0;\n\tmargin-left: 1ex;\n\tborder-bottom: 2px solid #cfeaf8;\n}\n\n#toptitle span.title-cldr {\n\tfont-weight: bold;\n}\n\n#toptitle h1 {\n\tdisplay: inline-block;\n\tfont-size: 28px;\n\tmargin: 0;\n}\n\n#toptitle h1::before {\n\tcontent: \" / \";\n}\n\n#toptitle #title-locale-container h1::before {\n\tcontent: \"\";\n}\n\n#itemInfo div.xpath {\n\tposition: fixed;\n\tright: 0.1em;\n\tbottom: 0.1em;\n\tcolor: #a19a9a;\n\tpadding:  2px;\n\tborder:  1px solid white;\n\tfont-family: \"Courier New\", Courier, mono;\n\tfont-weight: bold;\n}\n\n#itemInfo div.xpath:hover {\n\topacity: 1;\n\tcolor: navy;\n\tborder:  1px solid silver;\n\tbackground-color: white;\n}\n\n.beware-left-sidebar {\n\t/* The left sidebar \"slider\" width is 2% ( = 20% x 10%); cf. #itemInfo div.xpath */\n\tpadding-left: 2.1%;\n}\n\n#nav-page {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin: 0.25em 0.25em 0 0;\n\tpadding: 0;\n\tbox-sizing: border-box;\n}\n\n.cldr-nav-btn {\n\tpadding: 1px 5px;\n\tmargin-left: 0;\n\tmargin-right: 1ex;\n\tfont-size: 12px;\n\tline-height: 1.5;\n\tborder-radius: 3px;\n}\n\n.nav-progress {\n\twidth: 150px;\n\theight: 20px;\n\tmargin: 0 8px 4px 0;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n#VotingEtcSection {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: none;\n\toverflow: hidden;\n}\n\n#DynamicDataSection {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\toverflow: auto;\n}\n\n#DashboardSection {\n\twidth: 100%;\n\theight: 50%;\n\tdisplay: none;\n\tflex-direction: column;\n\toverflow: hidden;\n}\n\nfooter {\n\twidth: 100%;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\ttext-align: center;\n\tborder-top: 0.5em solid #eeeefe;\n\tfont-size: smaller;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
